import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Zona } from '../shared/zona.model';
import { LoaderService, NotificationService } from 'src/app/shared/session';
import { ZonaService } from '../shared/zona.service';

@Component({
  selector: 'app-zona-view',
  templateUrl: './zona-view.component.html',
})
export class ZonaViewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() titlePage: string;
  @Input() data: any;

  zona: Zona;
  msgErrorGet: string;

  constructor(
    private loaderService: LoaderService,
    private notificationService: NotificationService,
    private zonaService: ZonaService,
  ) { }

  ngOnInit() {
    this.initData();
  }

  async initData() {
    this.zona = new Zona();
    this.msgErrorGet = 'Error al obtener zona';
    this.loaderService.show();
    try {
      this.zona = await this.zonaService.obtenerZona(this.data.zona.id).toPromise();
    } catch (error) {
      this.notificationService.error(this.msgErrorGet);
      throw error;
    } finally {
      this.loaderService.hide();
    }
  }
}
